import Footer from './Footer.view';

export default Footer;
